import i18n from '../i18n/index';

export default {
  /**
   * @param selectedItems
   * @param items
   * @returns {string|*}
   */
  getNameFromFirstSelectedItem(selectedItems, items) {
    let finalString = '';
    if (selectedItems.length > 0) {
      finalString = items.find(item => item.id === selectedItems[0]).name;
      if (selectedItems.length > 1) {
        finalString += `
           + 
          ${selectedItems.length - 1} 
          ${i18n.tc('inputs.others', selectedItems.length - 1)}
        `;
      }
    } else {
      finalString += i18n.t('inputs.all');
    }
    return finalString;
  },
};



// WEBPACK FOOTER //
// ./src/services/utility-service.js